module.exports = __webpack_public_path__ + "static/BannerLetsTransform-79338fa08a8890ce51257d2e95713310.png";